import React from "react";
import EmslLayout from "../layouts/EmslLayout";
import EngagedHCP from "../summary/pages/EngagedHCP";
import ConsentedLeads from "../summary/pages/ConsentedLeads";
import InDemo from "../summary/pages/InDemo";
import ExpectedPrescribers from "../summary/pages/ExpectedPrescribers";
import LeadsDetails from "../summary/pages/LeadsDetails";

export const EmslRouter = [
  {
    path: "emsl",
    element: <EmslLayout />,
    children: [
      {
        path: "summary/engaged-hcps/:project_id",
        element: <EngagedHCP />,
      },
      {
        path: "summary/consented-leads/:project_id",
        element: <ConsentedLeads />,
      },
      {
        path: "summary/interactions/:project_id",
        element: <InDemo />,
      },
      {
        path: "summary/prescribers/:project_id",
        element: <ExpectedPrescribers />,
      },
      {
        path: "summary/:page_title/:project_id/leads/details/:leads_id",
        element: <LeadsDetails />,
      },
    ],
  },
];
